import { Info } from 'lucide-react'
import { type FC, memo } from 'react'

import { Popover, PopoverContent, PopoverTrigger } from '@fp/ui-kit'

export const ShowInfoPopover: FC<{ text: string }> = memo(({ text }) => (
  <Popover>
    <PopoverTrigger asChild className='cursor-pointer'>
      <Info className='w-4 h-4' />
    </PopoverTrigger>

    <PopoverContent className='w-80'>
      <p>{text}</p>
    </PopoverContent>
  </Popover>
))
ShowInfoPopover.displayName = 'ShowInfoPopover'
